import {
  MatrixTypes } from '../../enums/GameEnums';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../module/store/gameStore';
import { Matrix } from '../../components/matrix';
import { resultStore } from '../../module/store/resultStore';
import { Timer } from '../../components/timer/timer';
import { betStatus } from '../../enums/BetStatus';

export const WebGameScene = observer((props) => {

  const [isAnimationActive, setIsAnimationActive] = useState(true)

  const { matrixType, resultReportState, odds } = gameStore

  const { betResult, cashOutResult } = resultStore

  useEffect(() => {
    setIsAnimationActive(true)
  },[matrixType])

  return (
    <div className='mines-game-middle'>
      <div className='mines-game-middle-holder'>
        { resultReportState && !cashOutResult && betResult?.status !== betStatus.lose && <Timer /> }
        <div className={`m-game-mid-${(MatrixTypes[matrixType].type)}-wrp ${isAnimationActive ? 'animation-square-wrapper' : ''}`}
             onAnimationEnd={() => setIsAnimationActive(false)}>
          <Matrix matrixType={matrixType} matrix={resultStore.betResult?.matrix} odds={odds[MatrixTypes[matrixType].enumType]}/>
        </div>
      </div>
    </div>
  );
});
